import React, { useCallback, useEffect, useMemo } from "react";
import { Form, FormGroup, Input, Label, ModalBody } from "reactstrap";
import { useDropzone } from "react-dropzone";
import { BsFillCloudUploadFill } from "react-icons/bs";
import { AiFillCheckCircle } from "react-icons/ai";
import { HiDocumentText } from "react-icons/hi";
import EllipsisText from "react-ellipsis-text";

//i18n
import { withTranslation } from "react-i18next";

const SendModalBody = ({
  t,
  setName,
  setAcceptedFiles,
  setNote,
  setIsPrivate,
  isPrivate,
  filesToBeSent,
}) => {
  const onDrop = useCallback((acceptedFiles) => {
    setAcceptedFiles(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    maxSize: 1e7, // 10mb
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpg", "jpeg"],
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx"],
      "application/pdf": [".pdf"],
    },
    maxFiles: 10,
  });

  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    /* Skote/Light dark */

    background: "#2A3042",
    /* Elevation / 6 */
    border: "2px dashed #556EE6",
    borderRadius: "3px",
    color: "#bdbdbd",
    outline: "none",
    margin: "16px 0px",
    cursor: "pointer",
  };

  return (
    <ModalBody>
      <Form>
        <FormGroup>
          <Label for="attachmentName">
            {t("Name")}
            <span class="attachment-mandatory-field">*</span>
          </Label>
          <Input
            type="text"
            name="attachmentName"
            id="attachmentName"
            onChange={(e) => {
              setName(e?.target?.value);
            }}
            placeholder={t("Enter file name")}
            maxLength="200"
          />
        </FormGroup>
        <div style={baseStyle} {...getRootProps()}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>{t("Drag files here")}...</p>
          ) : (
            <>
              {filesToBeSent.length === 0 ? (
                <div class="col" id="attachment-upload-dropzone-wrapper">
                  <strong>{t("No file selected")}</strong>
                  <BsFillCloudUploadFill id="upload-logo" />
                  <p>{t("Drag and drop or select the file")}</p>
                </div>
              ) : (
                <div class="col" id="attachment-upload-dropzone-wrapper">
                  <strong>{t("Files uploaded successfully")}</strong>
                  <AiFillCheckCircle id="selected-files-logo" />
                  {filesToBeSent.map((file) => {
                    return (
                      <div id="individual-document">
                        <HiDocumentText id="document-logo" />
                        <EllipsisText text={file?.fileName} length={"45"} />
                      </div>
                    );
                  })}
                </div>
              )}
            </>
          )}
        </div>
        <div>
          <p>
            Limite: 10 arquivos | Tamanho máximo por arquivo: 10MB Extensões
            permitidas: .doc, .docx, .png, .jpg, .jpeg e .pdf
          </p>
        </div>
        <FormGroup>
          <Label for="attachmentNote">
            {t("Commentary")}
            <span class="attachment-mandatory-field">*</span>
          </Label>
          <Input
            type="text"
            name="attachmentNote"
            id="attachmentNote"
            onChange={(e) => {
              setNote(e?.target?.value);
            }}
            placeholder={t("Insert your comment")}
            maxLength="200"
          />
        </FormGroup>
        <FormGroup check>
          <Input
            type="checkbox"
            defaultChecked={isPrivate}
            onChange={(event) => {
              setIsPrivate(event?.target?.checked);
            }}
          />{" "}
          <Label check>{t(`Make file available in customer tracking`)}</Label>
        </FormGroup>
      </Form>
    </ModalBody>
  );
};

export default withTranslation()(SendModalBody);
